<template>
  <div class="page">
    <div id="content">
      <div class="grid-container techniken upfade">
        <div class="grid-x">
          <div class="cell small-12">
            <h1>Impressum</h1>
          </div>
          <div class="cell large-4">
            <h3>Angaben gemäß § 5 TMG</h3>
            <p>  Markus Kegel<br>
              Karlstraße 110<br>
              89073 Ulm<br><br>

              0176 . 64 97 49 62<br>
              <a href="mailto:hello@markus-kegel.de">hello@markus-kegel.de</a><br>
              <a href="http://www.markus-kegel.de" target="_blank">www.markus-kegel.de</a><br>

              <br><br>
              Diese Arbeit ist entstanden an der Hochschule Ausgburg im Wintersemester 2018/19 zur Erlangung des akademischen Grades Master of Arts.
            </p>
          </div>
          <div class="cell large-6 large-offset-2">
            <h3>Haftung für Inhalte</h3>
<p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>


<h3>Haftung für Links</h3>
<p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>


<h3>Urheberrecht</h3>
<p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
  };
</script>



<style scoped lang="scss">
.page{
  background-color: $black;


  p{
    color: #FFFFFF;
    margin-bottom: 96px;
  }

  #content{
    padding-top: 196px;
    padding-bottom: 196px;
    border: 0px;
    h1, h3{
      color: #FFFFFF;
    }

    h3{
      margin-bottom: 24px;
    }
  }
}
</style>
